var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-card",
    [
      _vm.$store.state.model.reservation.group_link_id == 0
        ? _c("v-card-title", { staticClass: "grey lighten-4 p-2" }, [
            _c("h4", { staticClass: "m-0" }, [_vm._v("Dates of Rental")]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "v-row",
        { staticClass: "m-2" },
        [
          _c(
            "v-col",
            { attrs: { cols: "12", md: "6", "order-md": "1" } },
            [
              _vm.$store.state.model.reservation.group_link_id == 0
                ? _c(
                    "v-row",
                    [
                      _c("v-col", { attrs: { cols: "12" } }, [
                        _c("div", { staticClass: "date-range-container" }, [
                          _c(
                            "div",
                            { staticClass: "date-range-icons" },
                            [_c("v-icon", [_vm._v("mdi-calendar-cursor")])],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "date-range-controls" },
                            [
                              _c(
                                "v-dialog",
                                {
                                  ref: "dateStartDialog",
                                  attrs: {
                                    "return-value": _vm.reservation.date_pickup,
                                    persistent: "",
                                    width: "290px",
                                  },
                                  on: {
                                    "update:returnValue": function ($event) {
                                      return _vm.$set(
                                        _vm.reservation,
                                        "date_pickup",
                                        $event
                                      )
                                    },
                                    "update:return-value": function ($event) {
                                      return _vm.$set(
                                        _vm.reservation,
                                        "date_pickup",
                                        $event
                                      )
                                    },
                                    input: _vm.changeDatePickerMonth,
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "activator",
                                        fn: function ({ on, attrs }) {
                                          return [
                                            _c("with-validation", {
                                              attrs: { field: "date_return" },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "default",
                                                    fn: function ({
                                                      bind: v_bind,
                                                    }) {
                                                      return [
                                                        _c(
                                                          "v-text-field",
                                                          _vm._g(
                                                            _vm._b(
                                                              {
                                                                attrs: {
                                                                  label:
                                                                    "Start Day",
                                                                  hint: "Day you start skiing?",
                                                                  "persistent-hint": true,
                                                                  error:
                                                                    v_bind.error,
                                                                  "error-messages":
                                                                    v_bind.errorMessages,
                                                                  readonly: "",
                                                                },
                                                                model: {
                                                                  value:
                                                                    _vm.datePickupFormatted,
                                                                  callback:
                                                                    function (
                                                                      $$v
                                                                    ) {
                                                                      _vm.datePickupFormatted =
                                                                        $$v
                                                                    },
                                                                  expression:
                                                                    "datePickupFormatted",
                                                                },
                                                              },
                                                              "v-text-field",
                                                              attrs,
                                                              false
                                                            ),
                                                            on
                                                          )
                                                        ),
                                                      ]
                                                    },
                                                  },
                                                ],
                                                null,
                                                true
                                              ),
                                            }),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    false,
                                    849056402
                                  ),
                                  model: {
                                    value: _vm.dateStartModal,
                                    callback: function ($$v) {
                                      _vm.dateStartModal = $$v
                                    },
                                    expression: "dateStartModal",
                                  },
                                },
                                [
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "datepicker-wrapper",
                                      on: { click: _vm.setDateReturn },
                                    },
                                    [
                                      _c(
                                        "h5",
                                        {
                                          staticClass:
                                            "datepicker-header primary text-center white--text pt-3 mb-0",
                                        },
                                        [
                                          _vm._v(
                                            "\n                                        Start Date\n                                    "
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-date-picker",
                                        {
                                          staticClass:
                                            "custom-current-date-black",
                                          staticStyle: {
                                            "border-top-left-radius": "0",
                                            "border-top-right-radius": "0",
                                          },
                                          attrs: {
                                            "allowed-dates":
                                              _vm.datePickupAllowedDate,
                                            scrollable: "",
                                          },
                                          on: {
                                            change: function ($event) {
                                              return _vm.validate([
                                                "date_pickup",
                                              ])
                                            },
                                            input: function ($event) {
                                              return _vm.$refs.dateStartDialog.save(
                                                _vm.reservation.date_pickup
                                              )
                                            },
                                          },
                                          model: {
                                            value: _vm.reservation.date_pickup,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.reservation,
                                                "date_pickup",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "reservation.date_pickup",
                                          },
                                        },
                                        [
                                          _c("v-spacer"),
                                          _vm._v(" "),
                                          _c(
                                            "v-btn",
                                            {
                                              attrs: {
                                                text: "",
                                                color: "primary",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  _vm.dateStartModal = false
                                                },
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                                            Cancel\n                                        "
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "v-dialog",
                                {
                                  ref: "dateEndDialog",
                                  attrs: {
                                    "return-value": _vm.reservation.date_return,
                                    persistent: "",
                                    width: "290px",
                                  },
                                  on: {
                                    "update:returnValue": function ($event) {
                                      return _vm.$set(
                                        _vm.reservation,
                                        "date_return",
                                        $event
                                      )
                                    },
                                    "update:return-value": function ($event) {
                                      return _vm.$set(
                                        _vm.reservation,
                                        "date_return",
                                        $event
                                      )
                                    },
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "activator",
                                        fn: function ({ on, attrs }) {
                                          return [
                                            _c(
                                              "v-slide-x-transition",
                                              [
                                                _c("with-validation", {
                                                  attrs: {
                                                    field: "date_return",
                                                  },
                                                  scopedSlots: _vm._u(
                                                    [
                                                      {
                                                        key: "default",
                                                        fn: function ({
                                                          bind: v_bind,
                                                        }) {
                                                          return [
                                                            _c(
                                                              "v-text-field",
                                                              _vm._g(
                                                                _vm._b(
                                                                  {
                                                                    staticClass:
                                                                      "ml-2",
                                                                    attrs: {
                                                                      label:
                                                                        "End Day",
                                                                      "persistent-hint": true,
                                                                      hint: "Last day skiing? ",
                                                                      readonly:
                                                                        "",
                                                                      error:
                                                                        v_bind.error,
                                                                      "error-messages":
                                                                        v_bind.errorMessages,
                                                                    },
                                                                    model: {
                                                                      value:
                                                                        _vm.dateReturnFormatted,
                                                                      callback:
                                                                        function (
                                                                          $$v
                                                                        ) {
                                                                          _vm.dateReturnFormatted =
                                                                            $$v
                                                                        },
                                                                      expression:
                                                                        "dateReturnFormatted",
                                                                    },
                                                                  },
                                                                  "v-text-field",
                                                                  attrs,
                                                                  false
                                                                ),
                                                                on
                                                              )
                                                            ),
                                                          ]
                                                        },
                                                      },
                                                    ],
                                                    null,
                                                    true
                                                  ),
                                                }),
                                              ],
                                              1
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    false,
                                    1121502917
                                  ),
                                  model: {
                                    value: _vm.dateEndModal,
                                    callback: function ($$v) {
                                      _vm.dateEndModal = $$v
                                    },
                                    expression: "dateEndModal",
                                  },
                                },
                                [
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "datepicker-wrapper" },
                                    [
                                      _c(
                                        "h5",
                                        {
                                          staticClass:
                                            "datepicker-header primary text-center white--text pt-3 mb-0",
                                        },
                                        [
                                          _vm._v(
                                            "\n                                        End Date\n                                    "
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-date-picker",
                                        {
                                          staticClass:
                                            "custom-current-date-black",
                                          staticStyle: {
                                            "border-top-left-radius": "0",
                                            "border-top-right-radius": "0",
                                          },
                                          attrs: {
                                            "allowed-dates":
                                              _vm.dateReturnAllowedDate,
                                            scrollable: "",
                                          },
                                          on: {
                                            change: function ($event) {
                                              return _vm.validate([
                                                "date_return",
                                              ])
                                            },
                                            input: function ($event) {
                                              return _vm.$refs.dateEndDialog.save(
                                                _vm.reservation.date_return
                                              )
                                            },
                                          },
                                          model: {
                                            value: _vm.reservation.date_return,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.reservation,
                                                "date_return",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "reservation.date_return",
                                          },
                                        },
                                        [
                                          _c("v-spacer"),
                                          _vm._v(" "),
                                          _c(
                                            "v-btn",
                                            {
                                              attrs: {
                                                text: "",
                                                color: "primary",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  _vm.dateEndModal = false
                                                },
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                                            Cancel\n                                        "
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ]),
                      ]),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "v-row",
                { staticClass: "mt-5" },
                [
                  _c(
                    "v-col",
                    {
                      staticClass: "flex-grow-0 align-self-end p-0",
                      staticStyle: { "flex-basis": "25px" },
                    },
                    [
                      _c(
                        "v-icon",
                        {
                          staticStyle: {
                            "margin-bottom": "10px",
                            "margin-left": "10px",
                          },
                        },
                        [_vm._v("mdi-account-multiple")]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-col",
                    [
                      _c("with-validation", {
                        attrs: { field: "reservees_number" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function ({ bind, on }) {
                              return [
                                _c(
                                  "v-v-step-number",
                                  _vm._g(
                                    _vm._b(
                                      {
                                        attrs: {
                                          min: 1,
                                          max:
                                            _vm.$store.state.resources.config
                                              .frontend_view_folder ===
                                            "frontend.tygart"
                                              ? 25
                                              : 20,
                                        },
                                      },
                                      "v-v-step-number",
                                      bind,
                                      false
                                    ),
                                    on
                                  )
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _vm.$store.state.model.reservation.group_link_id == 0
            ? _c(
                "v-col",
                { attrs: { "order-md": "2" } },
                [
                  _vm.is_local_accommodations
                    ? _c(
                        "v-col",
                        { attrs: { cols: "12" } },
                        [
                          _c("h5", [_vm._v("Delivery Location")]),
                          _vm._v(" "),
                          _c(
                            "v-row",
                            { staticClass: "m-2" },
                            [
                              _c("v-text-field", {
                                model: {
                                  value: _vm.reservation.local_accommodations,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.reservation,
                                      "local_accommodations",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "reservation.local_accommodations",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.is_delivery
                    ? _c(
                        "v-col",
                        { attrs: { cols: "12", "order-md": "3" } },
                        [
                          _c(
                            "v-alert",
                            { attrs: { outlined: "", elevation: "2" } },
                            [
                              _c(
                                "div",
                                { staticClass: "font-weight-bold mb-3" },
                                [
                                  _vm._v(
                                    "Today is " + _vm._s(_vm.todayFormatted)
                                  ),
                                ]
                              ),
                              _vm._v(
                                "\n                    *All reservations MUST be received no later than " +
                                  _vm._s(_vm.inAdvanceRentalDays * 24) +
                                  " hours in advance ( " +
                                  _vm._s(_vm.timezones[_vm.selectedTimezone]) +
                                  " ).\n\n                "
                              ),
                            ]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.is_coupon_show
                    ? _c(
                        "v-col",
                        { attrs: { cols: "12" } },
                        [
                          _c("h5", [_vm._v("Coupon")]),
                          _vm._v(" "),
                          _c(
                            "v-row",
                            { staticClass: "m-2" },
                            [
                              _c("v-text-field", {
                                model: {
                                  value: _vm.reservation.coupon_id,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.reservation, "coupon_id", $$v)
                                  },
                                  expression: "reservation.coupon_id",
                                },
                              }),
                              _vm._v(" "),
                              _c(
                                "v-btn",
                                {
                                  attrs: {
                                    color: "primary",
                                    disabled:
                                      _vm.book_me_host_code !== ""
                                        ? true
                                        : false,
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.applyCoupon()
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                        Apply\n                    "
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("v-row", { staticClass: "m-2" }, [
                            _c("span", {
                              class:
                                _vm.coupon_status === 200
                                  ? "text-success"
                                  : "text-danger",
                              domProps: {
                                innerHTML: _vm._s(_vm.coupon_response),
                              },
                            }),
                          ]),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.is_windhamoutfitters
                    ? _c(
                        "v-col",
                        { attrs: { cols: "12" } },
                        [
                          _c("h5", [_vm._v("Where will you be skiing today:")]),
                          _vm._v(" "),
                          _c("with-validation", {
                            attrs: { field: "location" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function ({ bind, on }) {
                                    return [
                                      _c(
                                        "v-select",
                                        _vm._g(
                                          _vm._b(
                                            {
                                              attrs: {
                                                "menu-props": "left",
                                                items: _vm.locationsList,
                                                "item-text": "title",
                                                "item-value": "key",
                                              },
                                            },
                                            "v-select",
                                            bind,
                                            false
                                          ),
                                          on
                                        )
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              299954791
                            ),
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _vm.$store.state.model.reservation.group_link_id == 0
        ? _c(
            "v-row",
            { staticClass: "m-2" },
            [
              _c(
                "v-col",
                { attrs: { cols: "12", md: "6" } },
                [
                  _vm._type === "advance" &&
                  (_vm.pickup_day_before || _vm.only_offer_day_before_pickup) &&
                  !_vm.reservation.is_delivery
                    ? [
                        _vm.$store.state.resources.config
                          .frontend_view_folder == "frontend.ridesnow"
                          ? [
                              _c(
                                "v-row",
                                { staticClass: "m-2" },
                                [
                                  _c("h6", [_vm._v("Day before")]),
                                  _vm._v(" "),
                                  _c(
                                    "v-row",
                                    [
                                      _c(
                                        "v-col",
                                        { attrs: { cols: "5" } },
                                        [
                                          _c(
                                            "v-radio-group",
                                            {
                                              attrs: { row: "" },
                                              model: {
                                                value:
                                                  _vm.reservation.pickup_day,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.reservation,
                                                    "pickup_day",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "reservation.pickup_day",
                                              },
                                            },
                                            [
                                              _c("v-radio", {
                                                attrs: {
                                                  label: "Yes",
                                                  value: "day_before",
                                                },
                                              }),
                                              _vm._v(" "),
                                              !_vm.only_offer_day_before_pickup
                                                ? _c("v-radio", {
                                                    attrs: {
                                                      label: "No",
                                                      value: "day_of",
                                                    },
                                                  })
                                                : _vm._e(),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-col",
                                        { attrs: { cols: "7" } },
                                        [
                                          _c("v-select", {
                                            attrs: {
                                              items:
                                                _vm.pickup_times[
                                                  _vm.reservation.pickup_day
                                                ],
                                              "item-value": "value",
                                              "item-text": "name",
                                              label: "Select pickup time",
                                            },
                                            model: {
                                              value:
                                                _vm.reservation.pickup_day_time,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.reservation,
                                                  "pickup_day_time",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "reservation.pickup_day_time",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ]
                          : [
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    display: "flex",
                                    "align-items": "flex-start",
                                    "justify-content": "space-between",
                                    width: "100%",
                                  },
                                },
                                [
                                  !_vm.is_backcountrysafary &&
                                  !_vm.is_adventure &&
                                  !_vm.is_essentials
                                    ? [
                                        _c(
                                          "div",
                                          [
                                            _c(
                                              "h5",
                                              [
                                                _c("v-icon", [
                                                  _vm._v("mdi-av-timer"),
                                                ]),
                                                _vm._v(" "),
                                                _c("span", [
                                                  _vm._v("Do you "),
                                                  _vm.is_velvetroperentals
                                                    ? _c("span", [
                                                        _vm._v("Deliver"),
                                                      ])
                                                    : _c("span", [
                                                        _vm._v(
                                                          "want to pick up "
                                                        ),
                                                      ]),
                                                  _vm._v(" the day before?"),
                                                ]),
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "v-radio-group",
                                              {
                                                attrs: { column: "" },
                                                model: {
                                                  value:
                                                    _vm.reservation.pickup_day,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.reservation,
                                                      "pickup_day",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "reservation.pickup_day",
                                                },
                                              },
                                              [
                                                _c("v-radio", {
                                                  attrs: {
                                                    value: "day_before",
                                                    label:
                                                      (_vm.is_velvetroperentals
                                                        ? "Delivery"
                                                        : "Pick up") +
                                                      " the day before " +
                                                      _vm.pick_up_day_before_text,
                                                  },
                                                }),
                                                _vm._v(" "),
                                                !_vm.only_offer_day_before_pickup
                                                  ? _c("v-radio", {
                                                      attrs: {
                                                        value: "day_of",
                                                        label:
                                                          (_vm.is_velvetroperentals
                                                            ? "Delivery"
                                                            : "Pick up") +
                                                          " day of",
                                                      },
                                                    })
                                                  : _vm._e(),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                      ]
                                    : _vm._e(),
                                ],
                                2
                              ),
                            ],
                        _vm._v(" "),
                        _vm.is_backcountrysafary ||
                        _vm.is_adventure ||
                        _vm.is_essentials
                          ? [
                              _c(
                                "v-row",
                                { staticClass: "m-2" },
                                [
                                  _c("h6", [_vm._v("Day before")]),
                                  _vm._v(" "),
                                  _c(
                                    "v-row",
                                    [
                                      _c(
                                        "v-col",
                                        { attrs: { cols: "5" } },
                                        [
                                          _c(
                                            "v-radio-group",
                                            {
                                              attrs: { row: "" },
                                              model: {
                                                value:
                                                  _vm.reservation.pickup_day,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.reservation,
                                                    "pickup_day",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "reservation.pickup_day",
                                              },
                                            },
                                            [
                                              _c("v-radio", {
                                                attrs: {
                                                  label: "Yes",
                                                  value: "day_before",
                                                },
                                              }),
                                              _vm._v(" "),
                                              !_vm.only_offer_day_before_pickup
                                                ? _c("v-radio", {
                                                    attrs: {
                                                      label: "No",
                                                      value: "day_of",
                                                    },
                                                  })
                                                : _vm._e(),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-col",
                                        { attrs: { cols: "7" } },
                                        [
                                          _c("v-select", {
                                            attrs: {
                                              items:
                                                _vm.pickup_times[
                                                  _vm.reservation.pickup_day
                                                ],
                                              "item-value": "value",
                                              "item-text": "time",
                                              label: "Select preferred time",
                                            },
                                            model: {
                                              value:
                                                _vm.reservation.pickup_day_time,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.reservation,
                                                  "pickup_day_time",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "reservation.pickup_day_time",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ]
                          : _vm._e(),
                      ]
                    : _vm._e(),
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "v-col",
                { attrs: { cols: "12", md: "6" } },
                [
                  _vm.return_day_after
                    ? [
                        _c(
                          "div",
                          [
                            _c(
                              "h5",
                              [
                                _c("v-icon", [_vm._v("mdi-av-timer")]),
                                _vm._v(" "),
                                _c("span", [
                                  _vm._v(
                                    "Do you want to return the day after?"
                                  ),
                                ]),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "v-radio-group",
                              {
                                attrs: { column: "" },
                                model: {
                                  value: _vm.reservation.return_day_after,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.reservation,
                                      "return_day_after",
                                      $$v
                                    )
                                  },
                                  expression: "reservation.return_day_after",
                                },
                              },
                              [
                                _c("v-radio", {
                                  attrs: { value: "yes", label: "Yes" },
                                }),
                                _vm._v(" "),
                                _c("v-radio", {
                                  attrs: { value: "no", label: "No" },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ]
                    : _vm._e(),
                ],
                2
              ),
              _vm._v(" "),
              _vm.is_adventure
                ? _c(
                    "v-col",
                    { attrs: { cols: "12", md: "6" } },
                    [
                      _c(
                        "v-row",
                        { staticClass: "m-2" },
                        [
                          _c("h6", [_vm._v("Please Select a Location:")]),
                          _vm._v(" "),
                          _c(
                            "v-radio-group",
                            {
                              attrs: { row: "" },
                              model: {
                                value: _vm.reservation.location,
                                callback: function ($$v) {
                                  _vm.$set(_vm.reservation, "location", $$v)
                                },
                                expression: "reservation.location",
                              },
                            },
                            [
                              _c("v-radio", {
                                attrs: {
                                  label: "South side Location",
                                  value: "south",
                                },
                              }),
                              _vm._v(" "),
                              _c("v-radio", {
                                attrs: {
                                  label: "North side Location",
                                  value: "north",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.is_backcountrysafary
                ? [
                    _c("v-col", { staticClass: "mt-7", attrs: { cols: "7" } }, [
                      _c("h6", [
                        _vm._v(
                          "Do you know the Property Name or Address you will be staying:"
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c(
                      "v-col",
                      { attrs: { cols: "5" } },
                      [
                        _c(
                          "v-radio-group",
                          {
                            attrs: { row: "" },
                            model: {
                              value: _vm.show_address_modal,
                              callback: function ($$v) {
                                _vm.show_address_modal = $$v
                              },
                              expression: "show_address_modal",
                            },
                          },
                          [
                            _c("v-radio", {
                              attrs: { label: "Yes", value: true },
                            }),
                            _vm._v(" "),
                            _c("v-radio", {
                              attrs: { label: "No", value: false },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]
                : _vm._e(),
            ],
            2
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }